import { render, staticRenderFns } from "./VipMessageBreakfast.vue?vue&type=template&id=1dea496e&scoped=true"
import script from "./VipMessageBreakfast.vue?vue&type=script&lang=js"
export * from "./VipMessageBreakfast.vue?vue&type=script&lang=js"
import style0 from "./VipMessageBreakfast.vue?vue&type=style&index=0&id=1dea496e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dea496e",
  null
  
)

export default component.exports